import { ReactElement } from 'react';

import { FlowModel } from '@/models/flow.model';
import { Member } from '@/types/invite-member.type';
import { InviteMemberStep, StepInfo } from '@/types/steps.type';

import { InviteTeamStep } from './InviteTeamStep';

export const InviteTeamStepInfo: StepInfo<InviteMemberStep> = {
  Component: InviteTeamStep,
  id: 'sendInvitesStep',
  stepName: 'Invite Employees Screen',
  title: 'onboarding:invite_members_step.title',
  desc: 'onboarding:invite_members_step.desc',
};

export type InviteOptionsProps = {
  flow: FlowModel;
  membersToInvite: Member[];
  onAddMoreClick: () => void;
  onSendInvites: () => void;
  renderMemberField: (member: Member, index: number) => ReactElement;
  onRemoveMemberClick: (index: string) => void;
  onBackClick: () => void;
  /** GrowthBook `invite-step-optimization` variation; for UI/display only */
  inviteOptimizationVariant?: string;
  /** When true (automatic/silent tracking), hide copy-invite-link actions */
  isAutomaticTracking?: boolean;
}

export { InviteStepCtx } from './InviteTeamStep';
